import { useState, useEffect } from 'react';
import { api } from '../../api';
import Modal from '../../components/Modal';

export default function VsfManagementPage() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [editVsf, setEditVsf] = useState(null);
  const [error, setError] = useState('');

  async function load() {
    try { setLocations(await api.getVsfLocations()); }
    catch (err) { setError(err.message); }
    setLoading(false);
  }

  useEffect(() => { load(); }, []); // eslint-disable-line

  async function handleDelete(id) {
    if (!window.confirm('Deactivate this VSF location?')) return;
    try { await api.deleteVsfLocation(id); load(); }
    catch (err) { alert(err.message); }
  }

  return (
    <div className="admin-page">
      <div className="page-header">
        <h2>VSF Locations</h2>
        <div className="header-actions">
          <button className="btn btn-primary" onClick={() => setShowCreate(true)}>+ Add VSF</button>
        </div>
      </div>
      {error && <div className="alert alert-error">{error}</div>}

      {loading ? <div className="loading">Loading...</div> : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr><th>Name</th><th>Address</th><th>City</th><th>State</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {locations.map(v => (
                <tr key={v.id}>
                  <td><strong>{v.name}</strong></td>
                  <td>{v.address}</td>
                  <td>{v.city}</td>
                  <td>{v.state}</td>
                  <td>
                    <button className="btn btn-sm btn-muted" onClick={() => setEditVsf(v)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(v.id)}>Delete</button>
                  </td>
                </tr>
              ))}
              {locations.length === 0 && (
                <tr><td colSpan={5} className="text-center text-muted">No VSF locations found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {showCreate && (
        <VsfFormModal
          onClose={() => setShowCreate(false)}
          onSaved={() => { setShowCreate(false); load(); }}
        />
      )}
      {editVsf && (
        <VsfFormModal
          vsf={editVsf}
          onClose={() => setEditVsf(null)}
          onSaved={() => { setEditVsf(null); load(); }}
        />
      )}
    </div>
  );
}

function VsfFormModal({ vsf, onClose, onSaved }) {
  const isEdit = !!vsf;
  const [form, setForm] = useState({
    name: vsf?.name || '',
    address: vsf?.address || '',
    city: vsf?.city || '',
    state: vsf?.state || 'TX',
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  function set(key, val) { setForm(f => ({ ...f, [key]: val })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      if (isEdit) await api.updateVsfLocation(vsf.id, form);
      else await api.createVsfLocation(form);
      onSaved();
    } catch (err) { setError(err.message); }
    setSubmitting(false);
  }

  return (
    <Modal title={isEdit ? 'Edit VSF Location' : 'Add VSF Location'} onClose={onClose}>
      {error && <div className="alert alert-error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>VSF Name</label>
          <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Addison VSF" required />
        </div>
        <div className="form-group">
          <label>Address</label>
          <input value={form.address} onChange={e => set('address', e.target.value)} placeholder="Street address" required />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>City</label>
            <input value={form.city} onChange={e => set('city', e.target.value)} placeholder="City" />
          </div>
          <div className="form-group">
            <label>State</label>
            <input value={form.state} onChange={e => set('state', e.target.value)} placeholder="TX" />
          </div>
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-muted" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Saving...' : (isEdit ? 'Save Changes' : 'Add VSF')}
          </button>
        </div>
      </form>
    </Modal>
  );
}
